import * as actionTypes from "../ActionTypes";

const initialState = {
  getAssets: [],
};

const store = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_ASSETS_INIT:
      return {
        ...state,
      };
    case actionTypes.GET_ASSETS_SUCCESS:
      return {
        ...state,
        getAssets: action.payload,
      };
    case actionTypes.GET_ASSETS_FAIL:
      return {
        ...state,
        error: "",
      };
    default:
      return state;
  }
};

export default store;
